import { useState } from "react";

export const useItemsPerPage = (initialItemsPerPage: number) => {
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);
  const [isItemsPerPageChanged, setIsItemsPerPageChanged] = useState(false);
  const [currentPageNo, setCurrentPageNo] = useState(1);

  const handleItemsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    setIsItemsPerPageChanged(true);
    setCurrentPageNo(1);
  };

  return {
    itemsPerPage,
    isItemsPerPageChanged,
    handleItemsPerPageChange,
    setIsItemsPerPageChanged,
    setItemsPerPage,
    currentPageNo,
    setCurrentPageNo,
  };
};
